// Service worker registration for production PWA builds.

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
        window.location.hostname === '[::1]' ||
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

type Config = {
    onSuccess?: (registration: ServiceWorkerRegistration) => void;
    onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
        return;
    }

    window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

        if (isLocalhost) {
            checkValidServiceWorker(swUrl, config);
            navigator.serviceWorker.ready.then(() => {
                console.info('[PWA] Service worker ready in localhost mode.');
            });
            return;
        }

        registerValidSW(swUrl, config);
    });
}

export function unregister() {
    if (!('serviceWorker' in navigator)) {
        return;
    }

    navigator.serviceWorker.ready
        .then((registration) => registration.unregister())
        .catch((error) => {
            console.error('[PWA] Service worker unregister failed:', error);
        });
}

function registerValidSW(swUrl: string, config?: Config) {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (!installingWorker) {
                    return;
                }

                installingWorker.onstatechange = () => {
                    if (installingWorker.state !== 'installed') {
                        return;
                    }

                    if (navigator.serviceWorker.controller) {
                        console.info('[PWA] New content available; refresh to update.');
                        config?.onUpdate?.(registration);
                    } else {
                        console.info('[PWA] Content cached for offline use.');
                        config?.onSuccess?.(registration);
                    }
                };
            };
        })
        .catch((error) => {
            console.error('[PWA] Service worker registration failed:', error);
        });
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
    fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
        .then((response) => {
            const contentType = response.headers.get('content-type');

            if (
                response.status === 404 ||
                (contentType && contentType.indexOf('javascript') === -1)
            ) {
                navigator.serviceWorker.ready.then((registration) => {
                    registration.unregister().then(() => {
                        window.location.reload();
                    });
                });
                return;
            }

            registerValidSW(swUrl, config);
        })
        .catch(() => {
            console.info('[PWA] No internet connection. App running in offline mode.');
        });
}
